<template>
  <!-- 详情 -->
  <a-modal
    title="详情"
    width="700px"
    :visible="DetailsVisible"
    :footer="null"
    :body-style="{ padding: '16px 24px' }"
    destroy-on-close
    @cancel="DetailsVisibleOK"
  >
    <a-descriptions bordered :column="2" size="small" class="detail-descriptions">
      <a-descriptions-item label="事件编号" :span="2">
        <span style="font-weight: 500;">{{ DetailsData.eventNo || '-' }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="事件名称" :span="2">{{ DetailsData.eventName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="事件来源">{{ DetailsData.source || '-' }}</a-descriptions-item>
      <a-descriptions-item label="关联编号">{{ DetailsData.associationNo || '-' }}</a-descriptions-item>
      <a-descriptions-item label="开始分类编号">{{ DetailsData.startClassNo || '-' }}</a-descriptions-item>
      <a-descriptions-item label="结束分类编号">{{ DetailsData.endClassNo || '-' }}</a-descriptions-item>
      <a-descriptions-item label="计划停水开始时间">{{ DetailsData.planStartTime || '-' }}</a-descriptions-item>
      <a-descriptions-item label="计划停水结束时间">{{ DetailsData.planEntTime || '-' }}</a-descriptions-item>
      <a-descriptions-item label="事件管理员">{{ DetailsData.adminName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="事件负责人">{{ DetailsData.principalName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="停水管理员">{{ DetailsData.waterAdminName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="创建人">{{ DetailsData.createName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{ DetailsData.createTime || '-' }}</a-descriptions-item>
      <!-- <a-descriptions-item label="停水影响区域" :span="2">{{ DetailsData.eventAddress || '-' }}</a-descriptions-item> -->
      <a-descriptions-item label="事件状态">
        <a-tag :color="DetailsData.status === 0 ? 'red' : 'green'">
          {{ DetailsData.status === 0 ? '未处理' : '已处理' }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="处理人">{{ DetailsData.handleName || '-' }}</a-descriptions-item>
      <a-descriptions-item label="处理时间">{{ DetailsData.handleTime || '-' }}</a-descriptions-item>
      <a-descriptions-item label="事件描述" :span="2">{{ DetailsData.describe || '-' }}</a-descriptions-item>
      <a-descriptions-item label="图片" :span="2">
        <template v-if="fileNamesimg && fileNamesimg.length > 0">
          <a-row :gutter="8">
            <a-col v-for="item in fileNamesimg" :key="item.url" :span="3">
              <div class="detail-img-wrap" @click="pumpurlimg(item.url)">
                <img :src="item.url" alt="" />
              </div>
            </a-col>
          </a-row>
        </template>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item label="文件" :span="2">
        <template v-if="fileNamestex && fileNamestex.length > 0">
          <div class="detail-file-list">
            <div v-for="item in fileNamestex" :key="item.url" class="detail-file-item" @click="uploadFile(item)">
              <a-icon type="paper-clip" style="margin-right: 4px;" />
              <a>{{ item.name || '附件' }}</a>
            </div>
          </div>
        </template>
        <span v-else>-</span>
      </a-descriptions-item>
    </a-descriptions>

    <!-- 地图 -->
    <a-modal
      class="log-form"
      :title="'选取位置'"
      width="50%"
      :visible="showMap"
      @ok="closeMap"
      @cancel="closeMap2"
    >
      <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
      <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
      <a-button type="submit" @click="searchMapLine">查询</a-button>
      <mapTemplate ref="waterMap"></mapTemplate>
    </a-modal>

    <!-- 图片 -->
    <a-modal
      title="图片"
      style="top: 20px"
      :width="800"
      :footer="null"
      :visible="visibles"
      :confirm-loading="confirmLoading"
      @cancel="handleCancelh"
    >
      <img :src="pumpUrlg" :alt="pumpUrlg" style="width: 100%; height: 100%" />
    </a-modal>
  </a-modal>
</template>

<script>
import mapTemplate from '../map-template.vue'
export default {
  components: {
    mapTemplate
  },
  data() {
    return {
      DetailsData: {},
      DetailsVisible: false,
      visibles: false,
      confirmLoading: false,
      startLine: '',
      endLine: '',
      showMap: false,
      pumpUrlg: '',
      fileNamestex: [],
      fileNamesimg: []
    }
  },
  methods: {
    DetailsVisibleOK() {
      this.DetailsVisible = false
      this.fileNamestex = []
      this.fileNamesimg = []
      this.DetailsData = {}
    },
    // 图片展示
    pumpurlimg(i) {
      this.pumpUrlg = i
      this.visibles = true
    },
    handleCancelh() {
      this.visibles = false
    },
    openMap() {
      this.startLine = this.DetailsData.startClassNo || ''
      this.endLine = this.DetailsData.endClassNo || ''
      this.showMap = true
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    isAssetTypeAnImage(ext) {
      const arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff']
      return arr.indexOf(ext.toLowerCase()) !== -1
    },
    ReassignHandle(id) {
      // 先清空旧数据，避免累积
      this.fileNamesimg = []
      this.fileNamestex = []
      this.DetailsData = {}
      if (id) {
        this.$http.get(`/pipe-network/gis_water_events/${id}`).then((res) => {
          this.DetailsVisible = true
          this.DetailsData = res.data
          if (res.data.fileNames && res.data.fileNames.length !== 0) {
            for (let i = 0; i < res.data.fileNames.length; i++) {
              const index = res.data.fileNames[i].url.lastIndexOf('.')
              const ext = res.data.fileNames[i].url.substr(index + 1)
              if (this.isAssetTypeAnImage(ext) === true) {
                this.fileNamesimg.push(res.data.fileNames[i])
              } else {
                this.fileNamestex.push(res.data.fileNames[i])
              }
            }
          }
        })
      }
    },
    uploadFile(item) {
      const link = document.createElement('a')
      link.download = item.name
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.detail-descriptions {
  /deep/ .ant-descriptions-item-label {
    width: 120px;
    text-align: right;
    background-color: #fafafa;
  }
}

.detail-img-wrap {
  cursor: pointer;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.detail-file-list {
  .detail-file-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    cursor: pointer;

    a {
      color: #1890ff;
    }

    &:hover a {
      text-decoration: underline;
    }
  }
}
</style>
